import { Toaster } from '#ui/sonner'

/**
 * The notices of both apps (Sonner), at the top in the middle, where the eye already is
 * after pressing a button. A success reads green and an error red, in the tones of the
 * status boxes (DESIGN.md: the `-strong` text on the `-soft` tint; `text-destructive` is
 * the red one), each with its icon.
 */
function AppToaster() {
	return (
		<Toaster
			position='top-center'
			toastOptions={{
				classNames: {
					toast: 'cn-toast',
					// Sonner styles its toast with attribute selectors: the tones need `!` to win.
					success:
						'!border-transparent !bg-success-soft !text-success-strong',
					error: '!border-transparent !bg-destructive-soft !text-destructive'
				}
			}}
		/>
	)
}

export { AppToaster }
